import http from '../http-common'

export default class FeedbackServices {

    async send(data) {
        let res = await http.post(`v1/feedback`, data);
        return res.data;
    }
}
